import React from "react";
import AdminCrud from "./AdminCrud";

export default function AdminBlog() {
    return (
        <AdminCrud title="Blog" endpoint="/admin/blog" idField="post_id" testPrefix="blog"
                   columns={[
                       { key: "image", label: "Img", type: "image" },
                       { key: "title", label: "Titlu" },
                       { key: "category", label: "Categorie" },
                       { key: "published", label: "Publicat", type: "boolean" },
                       { key: "no_index", label: "NoIndex", type: "boolean" },
                   ]}
                   fields={[
                       { key: "title", label: "Titlu", required: true, colSpan: 2 },
                       { key: "slug", label: "Slug", required: true, colSpan: 2 },
                       { key: "category", label: "Categorie (ex: Securitate, Ghiduri, Știri)", colSpan: 2 },
                       { key: "excerpt", label: "Rezumat", type: "textarea", colSpan: 2 },
                       { key: "image", label: "Imagine", type: "image", colSpan: 2 },
                       { key: "content", label: "Conținut (Markdown)", type: "textarea", colSpan: 2 },
                       { key: "author", label: "Autor" },
                       { key: "published", label: "Publicat", type: "boolean" },
                       { key: "no_index", label: "Ascunde de Google (noindex)", type: "boolean" },
                       { key: "seo_title", label: "SEO Title (og:title)", colSpan: 2 },
                       { key: "seo_description", label: "SEO Description (og:description, Twitter Card)", type: "textarea", colSpan: 2 },
                   ]}
                   defaultItem={{ published: true, no_index: false, author: "" }} />
    );
}
